import * as types from '../types/google-address-verify-types';

const defaultState = {
    addressInput: '',
    addressPredictions: [],
    fetchingAddressPredictions: false,
    pendingAddressPredictionsFetch: false,
    selectedAddress: {},
    fetchingAddressDetails: false,
    forceAddressValidation: false,
    shouldDisplayComponent: true,
    hasSeenError: false,
    apiFailureState: false
};

const googleAddressReducers = (state = defaultState, action) => {
    const {
        addressInput,
        addressPredictions,
        fetchingAddressPredictions,
        pendingAddressPredictionsFetch,
        selectedAddress,
        fetchingAddressDetails,
        forceAddressValidation,
        shouldDisplayComponent,
        hasSeenError,
        apiFailureState
    } = state;

    switch (action.type) {
        case types.FETCHING_ADDRESS_PREDICTIONS:
            return {
                addressInput: addressInput,
                addressPredictions: addressPredictions,
                fetchingAddressPredictions: true,
                pendingAddressPredictionsFetch: false,
                selectedAddress: selectedAddress,
                fetchingAddressDetails: false,
                forceAddressValidation: false,
                shouldDisplayComponent: shouldDisplayComponent,
                hasSeenError: hasSeenError,
                apiFailureState: apiFailureState
            };
            break;
        case types.PENDING_ADDRESS_PREDICTIONS_FETCH:
            return {
                addressInput: addressInput,
                addressPredictions: addressPredictions,
                fetchingAddressPredictions: fetchingAddressPredictions,
                pendingAddressPredictionsFetch: action.isPending,
                selectedAddress: selectedAddress,
                fetchingAddressDetails: fetchingAddressDetails,
                forceAddressValidation: forceAddressValidation,
                shouldDisplayComponent: shouldDisplayComponent,
                hasSeenError: hasSeenError,
                apiFailureState: apiFailureState
            };
            break;
        case types.SET_ADDRESS_PREDICTIONS:
            return {
                addressInput: addressInput,
                addressPredictions: action.addressPredictions,
                fetchingAddressPredictions: false,
                pendingAddressPredictionsFetch: pendingAddressPredictionsFetch,
                selectedAddress: selectedAddress,
                fetchingAddressDetails: false,
                forceAddressValidation: false,
                shouldDisplayComponent: shouldDisplayComponent,
                hasSeenError: hasSeenError,
                apiFailureState: false
            };
            break;
        case types.FAILED_FETCHING_ADDRESS_PREDICTIONS:
            return {
                addressInput: addressInput,
                addressPredictions: [],
                fetchingAddressPredictions: false,
                pendingAddressPredictionsFetch: pendingAddressPredictionsFetch,
                selectedAddress: selectedAddress,
                fetchingAddressDetails: false,
                forceAddressValidation: false,
                shouldDisplayComponent: shouldDisplayComponent,
                hasSeenError: hasSeenError,
                apiFailureState: apiFailureState
            };
            break;
        case types.CLEAR_ADDRESS_PREDICTIONS:
            return {
                addressInput: addressInput,
                addressPredictions: [],
                fetchingAddressPredictions: false,
                pendingAddressPredictionsFetch: false,
                selectedAddress: selectedAddress,
                fetchingAddressDetails: fetchingAddressDetails,
                forceAddressValidation: false,
                shouldDisplayComponent: shouldDisplayComponent,
                hasSeenError: hasSeenError,
                apiFailureState: apiFailureState
            };
            break;
        case types.CLEAR_ADDRESS_INPUT:
            return {
                addressInput: '',
                addressPredictions: [],
                fetchingAddressPredictions: false,
                pendingAddressPredictionsFetch: false,
                selectedAddress: {},
                fetchingAddressDetails: false,
                forceAddressValidation: false,
                shouldDisplayComponent: shouldDisplayComponent,
                hasSeenError: hasSeenError,
                apiFailureState: apiFailureState
            };
            break;
        case types.UPDATE_ADDRESS_INPUT:
            return {
                addressInput: action.text,
                addressPredictions: addressPredictions,
                fetchingAddressPredictions: fetchingAddressPredictions,
                pendingAddressPredictionsFetch: pendingAddressPredictionsFetch,
                selectedAddress: {},
                fetchingAddressDetails: fetchingAddressDetails,
                forceAddressValidation: false,
                shouldDisplayComponent: shouldDisplayComponent,
                hasSeenError: hasSeenError,
                apiFailureState: apiFailureState
            };
            break;
        case types.SET_ACTIVE_PREDICTION:
            let newAddressPredictions = addressPredictions.map((item, idx) => {
                let newItem = Object.assign({}, item);
                newItem.active = (idx === action.index);
                return newItem;
            });
            return {
                addressInput: addressInput,
                addressPredictions: newAddressPredictions,
                fetchingAddressPredictions: false,
                pendingAddressPredictionsFetch: pendingAddressPredictionsFetch,
                selectedAddress: selectedAddress,
                fetchingAddressDetails: false,
                forceAddressValidation: false,
                shouldDisplayComponent: shouldDisplayComponent,
                hasSeenError: hasSeenError,
                apiFailureState: apiFailureState
            };
            break;
        case types.FETCHING_ADDRESS_DETAILS:
            return {
                addressInput: addressInput,
                addressPredictions: [],
                fetchingAddressPredictions: fetchingAddressPredictions,
                pendingAddressPredictionsFetch: pendingAddressPredictionsFetch,
                selectedAddress: selectedAddress,
                fetchingAddressDetails: true,
                forceAddressValidation: false,
                shouldDisplayComponent: shouldDisplayComponent,
                hasSeenError: hasSeenError,
                apiFailureState: apiFailureState
            };
            break;
        case types.FAILED_FETCHING_ADDRESS_DETAILS:
            return {
                addressInput: addressInput,
                addressPredictions: addressPredictions,
                fetchingAddressPredictions: fetchingAddressPredictions,
                pendingAddressPredictionsFetch: pendingAddressPredictionsFetch,
                selectedAddress: selectedAddress,
                fetchingAddressDetails: false,
                forceAddressValidation: false,
                shouldDisplayComponent: shouldDisplayComponent,
                hasSeenError: hasSeenError,
                apiFailureState: true
            };
            break;
        case types.SET_SELECTED_ADDRESS:
            return {
                addressInput: addressInput,
                addressPredictions: addressPredictions,
                fetchingAddressPredictions: fetchingAddressPredictions,
                pendingAddressPredictionsFetch: pendingAddressPredictionsFetch,
                selectedAddress: action.selectedAddress,
                fetchingAddressDetails: false,
                forceAddressValidation: false,
                shouldDisplayComponent: shouldDisplayComponent,
                hasSeenError: hasSeenError,
                apiFailureState: apiFailureState
            };
            break;
        case types.FORCE_ADDRESS_VALIDATION:
            return {
                addressInput: addressInput,
                addressPredictions: addressPredictions,
                fetchingAddressPredictions: fetchingAddressPredictions,
                pendingAddressPredictionsFetch: pendingAddressPredictionsFetch,
                selectedAddress: selectedAddress,
                fetchingAddressDetails: fetchingAddressDetails,
                forceAddressValidation: action.shouldForceValidation,
                shouldDisplayComponent: shouldDisplayComponent,
                hasSeenError: hasSeenError,
                apiFailureState: apiFailureState
            };
            break;
        case types.SET_API_FALIURE_STATE:
            return {
                addressInput: addressInput,
                addressPredictions: addressPredictions,
                fetchingAddressPredictions: fetchingAddressPredictions,
                pendingAddressPredictionsFetch: pendingAddressPredictionsFetch,
                selectedAddress: selectedAddress,
                fetchingAddressDetails: fetchingAddressDetails,
                forceAddressValidation: forceAddressValidation,
                shouldDisplayComponent: shouldDisplayComponent,
                hasSeenError: hasSeenError,
                apiFailureState: action.isFailureState
            };
            break;
        case types.SET_HAS_SEEN_ERROR:
            return {
                addressInput: addressInput,
                addressPredictions: addressPredictions,
                fetchingAddressPredictions: fetchingAddressPredictions,
                pendingAddressPredictionsFetch: pendingAddressPredictionsFetch,
                selectedAddress: selectedAddress,
                fetchingAddressDetails: fetchingAddressDetails,
                forceAddressValidation: forceAddressValidation,
                shouldDisplayComponent: shouldDisplayComponent,
                hasSeenError: action.hasSeen,
                apiFailureState: apiFailureState
            };
            break;
        case types.SET_SHOULD_DISPLAY_COMPONENT:
            return {
                addressInput: addressInput,
                addressPredictions: addressPredictions,
                fetchingAddressPredictions: fetchingAddressPredictions,
                pendingAddressPredictionsFetch: pendingAddressPredictionsFetch,
                selectedAddress: selectedAddress,
                fetchingAddressDetails: fetchingAddressDetails,
                forceAddressValidation: forceAddressValidation,
                shouldDisplayComponent: action.shouldDisplay,
                hasSeenError: hasSeenError,
                apiFailureState: apiFailureState
            };
            break;
        default:
            return {
                addressInput: addressInput,
                addressPredictions: addressPredictions,
                fetchingAddressPredictions: fetchingAddressPredictions,
                pendingAddressPredictionsFetch: pendingAddressPredictionsFetch,
                selectedAddress: selectedAddress,
                fetchingAddressDetails: fetchingAddressDetails,
                forceAddressValidation: forceAddressValidation,
                shouldDisplayComponent: shouldDisplayComponent,
                hasSeenError: hasSeenError,
                apiFailureState: apiFailureState
            };
            break;
    }
};

export default googleAddressReducers;
